import { Browser } from '../device-permission.types';

export const detectBrowserName = (): Browser => {
	const agent = window.navigator.userAgent.toLowerCase();
	const browserWindow = window as typeof window & { chrome?: unknown; opr?: unknown };
	switch (true) {
		case agent.includes('edge') || agent.includes('edg/'):
			return 'edge';
		case agent.includes('opr') && !!browserWindow.opr:
			return 'opera';
		case agent.includes('chrome') && !!browserWindow.chrome:
			return 'chrome';
		case agent.includes('trident'):
			return 'ie';
		case agent.includes('firefox'):
			return 'firefox';
		case agent.includes('safari'):
			return 'safari';
		default:
			return 'other';
	}
};
